import React from "react";
import { Alert, Col, FormGroup, Label, Row } from "reactstrap";
import { RadioButton } from "primereact/radiobutton";

import TextInput from "./TextInput";

export const BILLING_FIELD_MAX_LENGTHS = {
  billToEntityNameAndAddress: 500,
  billingContactPhone: 50,
  billingInvoiceCopyEmail: 350,
  billingPoNumber: 200,
  billingVendorPortalName: 350,
};

export const BILLING_FIELD_LABELS = {
  billingContactName: "Billing Contact name",
  billingContactEmail: "Billing Contact email",
  billToEntityNameAndAddress: "Bill To (Entity) Name and Address",
  billingContactPhone: "Billing Contact Phone Number",
  billingInvoiceCopyEmail: "Invoice copy email address",
  billingPoNumber: "PO/WO number",
  billingVendorPortalName: "Vendor portal name",
};

const YesNoQuestion = ({ name, question, value, disabled, onChange }) => (
  <>
    <Label className="d-block">
      <b>{question}</b>
    </Label>
    <span style={{ marginRight: "2em" }}>
      <RadioButton
        inputId={`${name}-yes`}
        name={name}
        value={true}
        checked={value === true}
        disabled={disabled}
        onChange={() => onChange(true)}
      />
      <Label
        htmlFor={`${name}-yes`}
        style={{ marginLeft: "0.5em", marginRight: "1.5em" }}
      >
        Yes
      </Label>
    </span>
    <span>
      <RadioButton
        inputId={`${name}-no`}
        name={name}
        value={false}
        checked={value === false}
        disabled={disabled}
        onChange={() => onChange(false)}
      />
      <Label htmlFor={`${name}-no`} style={{ marginLeft: "0.5em" }}>
        No
      </Label>
    </span>
  </>
);

export const BillingContactSection = ({
  values,
  answers,
  onChange,
  disabled,
  billingEmailErrorMessage,
  billingPhoneErrorMessage,
}) => (
  <Alert color="info">
    <h5>Billing Contact information</h5>
    <FormGroup>
      <Row>
        <Col md={6}>
          <TextInput
            label={BILLING_FIELD_LABELS.billingContactName}
            disabled={disabled}
            initialValue={values.billingContactName}
            updateParent={(billingContactName) => onChange({ billingContactName })}
          />
        </Col>
        <Col md={6}>
          <TextInput
            label={BILLING_FIELD_LABELS.billingContactEmail}
            disabled={disabled}
            initialValue={values.billingContactEmail}
            updateParent={(billingContactEmail) => onChange({ billingContactEmail })}
            error={billingEmailErrorMessage}
          />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md={6}>
          <TextInput
            label={BILLING_FIELD_LABELS.billToEntityNameAndAddress}
            disabled={disabled}
            maxLength={BILLING_FIELD_MAX_LENGTHS.billToEntityNameAndAddress}
            initialValue={values.billToEntityNameAndAddress}
            updateParent={(billToEntityNameAndAddress) =>
              onChange({ billToEntityNameAndAddress })
            }
          />
        </Col>
        <Col md={6}>
          <TextInput
            label={BILLING_FIELD_LABELS.billingContactPhone}
            disabled={disabled}
            maxLength={BILLING_FIELD_MAX_LENGTHS.billingContactPhone}
            initialValue={values.billingContactPhone}
            updateParent={(billingContactPhone) => onChange({ billingContactPhone })}
            error={billingPhoneErrorMessage}
          />
        </Col>
      </Row>
    </FormGroup>

    <Row className="mt-3">
      <Col md={6}>
        <YesNoQuestion
          name="billingInvoiceCopyRequired"
          question="Invoice copy sent to email?"
          value={answers.billingInvoiceCopyRequired}
          disabled={disabled}
          onChange={(billingInvoiceCopyRequired) =>
            onChange({ billingInvoiceCopyRequired })
          }
        />
      </Col>
      <Col md={6}>
        <TextInput
          label={BILLING_FIELD_LABELS.billingInvoiceCopyEmail}
          disabled={disabled || answers.billingInvoiceCopyRequired !== true}
          maxLength={BILLING_FIELD_MAX_LENGTHS.billingInvoiceCopyEmail}
          initialValue={values.billingInvoiceCopyEmail}
          updateParent={(billingInvoiceCopyEmail) =>
            onChange({ billingInvoiceCopyEmail })
          }
        />
      </Col>
    </Row>

    <Row className="mt-3">
      <Col md={6}>
        <YesNoQuestion
          name="billingPoRequired"
          question="Will a PO/WO be required?"
          value={answers.billingPoRequired}
          disabled={disabled}
          onChange={(billingPoRequired) => onChange({ billingPoRequired })}
        />
      </Col>
      <Col md={6}>
        <TextInput
          label={BILLING_FIELD_LABELS.billingPoNumber}
          disabled={disabled || answers.billingPoRequired !== true}
          maxLength={BILLING_FIELD_MAX_LENGTHS.billingPoNumber}
          initialValue={values.billingPoNumber}
          updateParent={(billingPoNumber) => onChange({ billingPoNumber })}
        />
      </Col>
    </Row>

    <Row className="mt-3">
      <Col md={6}>
        <YesNoQuestion
          name="billingVendorPortalRequired"
          question="Vendor compliance/billing portal required?"
          value={answers.billingVendorPortalRequired}
          disabled={disabled}
          onChange={(billingVendorPortalRequired) =>
            onChange({ billingVendorPortalRequired })
          }
        />
      </Col>
      <Col md={6}>
        <TextInput
          label={BILLING_FIELD_LABELS.billingVendorPortalName}
          disabled={disabled || answers.billingVendorPortalRequired !== true}
          maxLength={BILLING_FIELD_MAX_LENGTHS.billingVendorPortalName}
          initialValue={values.billingVendorPortalName}
          updateParent={(billingVendorPortalName) =>
            onChange({ billingVendorPortalName })
          }
        />
      </Col>
    </Row>
  </Alert>
);
